module.exports = __webpack_public_path__ + "img/chp-black.0837287e.svg";